import React, { useContext, useState } from 'react'
import CourseItem from '../Utilities/CourseItem'
import PageTitle from '../Utilities/PageTitle'
import axios from 'axios';
import { useEffect } from 'react';
import { BaseUrlContext } from '../Context/BaseUrl';

export default function Courses() {

    const { baseUrl, imgUrl } = useContext(BaseUrlContext);
    let [courses, setCourses] = useState([]);
    async function getAllCourses() {

        await axios.post(`${baseUrl}/get_courses`)
            .then(response => {
                // Handle the response
                if (response.data.Ecode === 200) {
                    console.log(response.data.Edata);
                    setCourses(response.data.Edata);
                }

            })
            .catch(error => {

                // Handle any errors
                console.error(error);
            });

    }
    useEffect(() => {
        getAllCourses();
    }, [])
    return <>
        <div className="main-content-area">
            <PageTitle title='Courses' homeLink='/' homePage='Home' currentLink='/courses' />
            <section className="bg-silver-light">
                <div className="container py-md-5 py-4">
                    <div className="section-title">
                        <div className="row">
                            <div className="col-md-8">
                                <div className="mb-60">
                                    <div className="tm-sc tm-sc-section-title section-title">
                                        <div className="title-wrapper">
                                            <h2 className="text-uppercase line-bottom line-bottom-theme-colored1">Our <span className="text-theme-colored1">Courses</span></h2>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="section-content">
                        <div className="row">
                            {courses.map((course, index) => <>
                                <CourseItem key={index} imgSrc={`${imgUrl}${course.image}`} imgAlt={course.name} courseTitle={course.name} courseHours={course.Hours} CourseBrief={(course.description).split(' ').slice(0, 20).join(' ')}
                                    sessions={course.sessions_per_month} courseFees={course.fees} courseDetails={`${course.name}/${course.id}`} />

                            </>)}

                        </div>
                    </div>
                </div>

            </section>
        </div>
    </>
}
